export const LOGIN_CARD = {
    TITLE: 'Welcome back!',
}
